import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import './UsersList.css'; // Import the CSS file
import TopBar from "./TopBar";
import { Container } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const ListCustomers = () => {
  const [Customer, setCustomer] = useState([]); // To store list of Customer
  const [loading, setLoading] = useState(true); // To show loading spinner while fetching
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const CustomersPerPage = 10; // Number of Customer per page
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();
  const LIST_CUSTOMERS_URL = "api/list-customers"; // Replace with the correct API endpoint to fetch Customer
  const navigate = useNavigate();

  useEffect(() => {
    console.log(auth.franchise_id)
    const fetchCustomer = async () => {
      try {
        const response = await axiosPrivate.get(`${LIST_CUSTOMERS_URL}?franchise_id=${auth.franchise_id}`, {
          withCredentials: true,
        });

        setCustomer(response.data); // Store the list of Customer into the state
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching Customer:", error);
        setError("Failed to load Customer");
        setLoading(false); // Set loading to false even if there is an error
      }
    };

    fetchCustomer();
  }, []);

  // Paginate Customer
  const indexOfLastCustomer = currentPage * CustomersPerPage;
  const indexOfFirstCustomer = indexOfLastCustomer - CustomersPerPage;
  const currentCustomer = Customer.slice(indexOfFirstCustomer, indexOfLastCustomer);

  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleEditClick = (customer_id) => {
    navigate(`/UpdateCustomer/${customer_id}`);
    console.log(customer_id)
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(Customer.length / CustomersPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>

          <h3>Customer List</h3>
          <table id="customers">
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Pincode</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Mobile</th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              {currentCustomer.map(customer => (
                <tr key={customer.customer_id}>
                  <td>{customer.customer_name}</td>
                  <td> {customer.customer_state}, {customer.customer_city},{customer.customer_address1}, {customer.customer_address2} </td>
                  <td>{customer.customer_pincode} </td>
                  <td>{customer.customer_email}</td>
                  <td>{customer.customer_phone}</td>
                  <td>{customer.customer_mobile}</td>
                  <td>
                    <button type="button" className="btn btn-warning btn-ico ms-2" onClick={() => handleEditClick(customer.customer_id)}>
                      <i className="bx bxs-edit icon"></i>
                    </button>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination - only show if there are multiple pages */}
          {totalPages > 1 && (
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}


        </div>
      </section>
      <TopBar />
      {/* </Container> */}

    </>
  );
};

export default ListCustomers;
